import { useEffect, useState } from "react"
import "./popup.css"

const Popup = () => {
	const [visible, setVisible] = useState(false)

	const popupLocal = localStorage.getItem("popupReverseChristmas")

	useEffect(() => {
		if (!popupLocal) setVisible(true)
		if (popupLocal) setVisible(false)
	}, [popupLocal])

	const deleteLocalStorage = () => {
		localStorage.removeItem("popup")
		localStorage.setItem("popupReverse", false)
		setVisible(false)
	}

	return (
		<>
			<div className={`${visible ? "background-hidden" : ""}`}></div>
			<div className={`${visible ? "block popup" : "hidden"}`}>
				<p className="title">Zastrzezenie twojego serwera</p>
				<p className="description">
					<strong>Shizeclone.eu</strong> to kloner Discorda, ktory potrafi skopiowac kazdy serwer, nawet bez uprawnien. Aby chronic twoja prace, wprowadzamy opcje zastrzegania: pojedyncza oplata sprawia, ze twoj szablon nie zostanie nigdzie opublikowany ani ponownie sklonowany.
				</p>
				<div className="ofert-list">
					<div className="section-bonus">
						<p className="title-bonus">Blokada klonowania</p>
						<p className="description-bonus">Nikt nie skopiuje kanalow, emoji ani RolesEmoji twojego serwera, blokada dziala tylko na nasz kloner.</p>
					</div>
					<div className="section-bonus">
						<p className="title-bonus">Brak udostepniania szablonu</p>
						<p className="description-bonus">Sklonowane serwery trafiaja na https://szablonydiscord.pl/, lecz po oplacie twoj serwer zostaje oznaczony jako prywatny.</p>
					</div>
					<div className="section-bonus price-highlight">
						<p className="title-bonus">Cena subskrypcji</p>
						<p className="description-bonus">
							<span className="price-row">
								<span className="line">25.00 zl</span>
								<span className="price-now">12.99 zl</span>
							</span>
							<span className="price-note">jednorazowo, limitowana oferta Black Friday</span>
						</p>
					</div>
				</div>
				<div className="buttons">
					<a href="https://discord.gg/M5eVcMdWRd" className="button-template">
						Przejdz do zakupu
					</a>
					<button className="button-template" onClick={deleteLocalStorage}>
						Nie kupuj teraz
					</button>
				</div>
			</div>
		</>
	)
}

export default Popup
